import { Action, ActionType } from "./actionTypes";
import { Dispatch } from "redux";

export const walletConnection = (isConnected: boolean, publicKey: string, chainID: any, walletType: string) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.WALLET_CONNECTION,
      payload: {
        isConnected: isConnected,
        publicKey: publicKey,
        chainID: chainID,
        walletType: walletType
      }
    })
  }
}